export const homeDecor = [
  {
    name: "Flower T - Light (Midnight Black)",
    slug: "flower-t-light-midnight-black",
    MRP: 950,
    sellingPrice: 600,
    category: {
      data: {
        attributes: {
          name: "T-Light",
          __typename: "Category",
        },
        __typename: "CategoryEntity",
      },
      __typename: "CategoryEntityResponse",
    },
    stock: 2,
    images: {
      data: [
        {
          attributes: {
            alternativeText: null,
            url: "/images/products/pixelcut_export_50_56bc89cdf4.jpeg",
            size: 400.3,
            __typename: "UploadFile",
          },
          __typename: "UploadFileEntity",
        },
        {
          attributes: {
            alternativeText: "flower-t-midnight-black",
            url: "/images/products/flower_t_black_55eefb9ca1.webp",
            size: 43.04,
            __typename: "UploadFile",
          },
          __typename: "UploadFileEntity",
        },
      ],
      __typename: "UploadFileRelationResponseCollection",
    },
    __typename: "ProductEntity",
  },
  {
    name: "Tulip Amber",
    slug: "tulip-amber",
    MRP: 2199,
    sellingPrice: 1750,
    category: {
      data: {
        attributes: {
          name: "Tulip",
          __typename: "Category",
        },
        __typename: "CategoryEntity",
      },
      __typename: "CategoryEntityResponse",
    },
    stock: 2,
    images: {
      data: [
        {
          attributes: {
            alternativeText: "Tulip Amber0",
            url: "/images/products/Tulip_Amber_f9c18d3eca.webp",
            size: 111.02,
            __typename: "UploadFile",
          },
          __typename: "UploadFileEntity",
        },
        {
          attributes: {
            alternativeText: "Tulip Amber1",
            url: "/images/products/Tulip_Amber_65e907b19d.webp",
            size: 72.95,
            __typename: "UploadFile",
          },
          __typename: "UploadFileEntity",
        },
      ],
      __typename: "UploadFileRelationResponseCollection",
    },
    __typename: "ProductEntity",
  },
  {
    name: "Tulip Black Knight",
    slug: "tulip-black-knight",
    MRP: 2199,
    sellingPrice: 1750,
    category: {
      data: {
        attributes: {
          name: "Tulip",
          __typename: "Category",
        },
        __typename: "CategoryEntity",
      },
      __typename: "CategoryEntityResponse",
    },
    stock: 2,
    images: {
      data: [
        {
          attributes: {
            alternativeText: null,
            url: "/images/products/pixelcut_export_60_ee9fc6ab6c.jpeg",
            size: 489.27,
            __typename: "UploadFile",
          },
          __typename: "UploadFileEntity",
        },
        {
          attributes: {
            alternativeText: "Tulip Black Knight1",
            url: "/images/products/Tulip_Black_Knight_87e2296d1d.webp",
            size: 21.72,
            __typename: "UploadFile",
          },
          __typename: "UploadFileEntity",
        },
      ],
      __typename: "UploadFileRelationResponseCollection",
    },
    __typename: "ProductEntity",
  },
  {
    name: "Tulip Clear",
    slug: "tulip-clear",
    MRP: 850,
    sellingPrice: 650,
    category: {
      data: {
        attributes: {
          name: "Tulip",
          __typename: "Category",
        },
        __typename: "CategoryEntity",
      },
      __typename: "CategoryEntityResponse",
    },
    stock: 2,
    images: {
      data: [
        {
          attributes: {
            alternativeText: "Tulip Clear0",
            url: "/images/products/Tulip_Clear_c67bfa4efa.webp",
            size: 89.41,
            __typename: "UploadFile",
          },
          __typename: "UploadFileEntity",
        },
      ],
      __typename: "UploadFileRelationResponseCollection",
    },
    __typename: "ProductEntity",
  },
  {
    name: "Tulip Crystal",
    slug: "tulip-crystal",
    MRP: 2199,
    sellingPrice: 1750,
    category: {
      data: {
        attributes: {
          name: "Tulip",
          __typename: "Category",
        },
        __typename: "CategoryEntity",
      },
      __typename: "CategoryEntityResponse",
    },
    stock: 2,
    images: {
      data: [
        {
          attributes: {
            alternativeText: "Tulip Crystal0",
            url: "/images/products/Tulip_Crystal_ed7a511ac0.webp",
            size: 51.3,
            __typename: "UploadFile",
          },
          __typename: "UploadFileEntity",
        },
      ],
      __typename: "UploadFileRelationResponseCollection",
    },
    __typename: "ProductEntity",
  },
  {
    name: "Tulip Ebony",
    slug: "tulip-ebony",
    MRP: 850,
    sellingPrice: 650,
    category: {
      data: {
        attributes: {
          name: "Tulip",
          __typename: "Category",
        },
        __typename: "CategoryEntity",
      },
      __typename: "CategoryEntityResponse",
    },
    stock: 2,
    images: {
      data: [
        {
          attributes: {
            alternativeText: "Tulip Ebony0",
            url: "/images/products/Tulip_Ebony_bb06af42d8.webp",
            size: 29.92,
            __typename: "UploadFile",
          },
          __typename: "UploadFileEntity",
        },
      ],
      __typename: "UploadFileRelationResponseCollection",
    },
    __typename: "ProductEntity",
  },
  {
    name: "Tulip Emerald",
    slug: "tulip-emerald",
    MRP: 850,
    sellingPrice: 650,
    category: {
      data: {
        attributes: {
          name: "Tulip",
          __typename: "Category",
        },
        __typename: "CategoryEntity",
      },
      __typename: "CategoryEntityResponse",
    },
    stock: 2,
    images: {
      data: [
        {
          attributes: {
            alternativeText: "Tulip Emerald0",
            url: "/images/products/Tulip_Emerald_9796664cc0.webp",
            size: 83.61,
            __typename: "UploadFile",
          },
          __typename: "UploadFileEntity",
        },
      ],
      __typename: "UploadFileRelationResponseCollection",
    },
    __typename: "ProductEntity",
  },
  {
    name: "Tulip Mocha",
    slug: "tulip-mocha",
    MRP: 850,
    sellingPrice: 650,
    category: {
      data: {
        attributes: {
          name: "Tulip",
          __typename: "Category",
        },
        __typename: "CategoryEntity",
      },
      __typename: "CategoryEntityResponse",
    },
    stock: 2,
    images: {
      data: [
        {
          attributes: {
            alternativeText: "brown tulip set of 2",
            url: "/images/products/brown_tulip_set_of_2_a0ecc04acf.webp",
            size: 49.85,
            __typename: "UploadFile",
          },
          __typename: "UploadFileEntity",
        },
        {
          attributes: {
            alternativeText: "Tulip Mocha0",
            url: "/images/products/Tulip_Mocha_5e52ea97ae.webp",
            size: 83.48,
            __typename: "UploadFile",
          },
          __typename: "UploadFileEntity",
        },
      ],
      __typename: "UploadFileRelationResponseCollection",
    },
    __typename: "ProductEntity",
  },
  {
    name: "Tulip Sapphire",
    slug: "tulip-sapphire",
    MRP: 2199,
    sellingPrice: 1750,
    category: {
      data: {
        attributes: {
          name: "Tulip",
          __typename: "Category",
        },
        __typename: "CategoryEntity",
      },
      __typename: "CategoryEntityResponse",
    },
    stock: 2,
    images: {
      data: [
        {
          attributes: {
            alternativeText: "Blue Tulip Big andgle 2",
            url: "/images/products/Blue_Tulip_Big_andgle_2_b898fdd518.webp",
            size: 53.54,
            __typename: "UploadFile",
          },
          __typename: "UploadFileEntity",
        },
        {
          attributes: {
            alternativeText: "Blue Tulip Big",
            url: "/images/products/Blue_Tulip_Big_75dbdbbea9.webp",
            size: 50.49,
            __typename: "UploadFile",
          },
          __typename: "UploadFileEntity",
        },
      ],
      __typename: "UploadFileRelationResponseCollection",
    },
    __typename: "ProductEntity",
  },
  {
    name: "Tulip Small Blue",
    slug: "tulip-small-blue",
    MRP: 850,
    sellingPrice: 650,
    category: {
      data: {
        attributes: {
          name: "Tulip",
          __typename: "Category",
        },
        __typename: "CategoryEntity",
      },
      __typename: "CategoryEntityResponse",
    },
    stock: 2,
    images: {
      data: [
        {
          attributes: {
            alternativeText: "Tulip Small Blue0",
            url: "/images/products/Tulip_Small_Blue_8353c71e32.webp",
            size: 60.9,
            __typename: "UploadFile",
          },
          __typename: "UploadFileEntity",
        },
        {
          attributes: {
            alternativeText: "Tulip Small Blue1",
            url: "/images/products/Tulip_Small_Blue_8d722c4065.webp",
            size: 60.9,
            __typename: "UploadFile",
          },
          __typename: "UploadFileEntity",
        },
      ],
      __typename: "UploadFileRelationResponseCollection",
    },
    __typename: "ProductEntity",
  },
  {
    name: "Tulip Spring Green",
    slug: "tulip-spring-green",
    MRP: 2199,
    sellingPrice: 1750,
    category: {
      data: {
        attributes: {
          name: "Tulip",
          __typename: "Category",
        },
        __typename: "CategoryEntity",
      },
      __typename: "CategoryEntityResponse",
    },
    stock: 2,
    images: {
      data: [
        {
          attributes: {
            alternativeText: "green tulip big",
            url: "/images/products/green_tulip_big_491f589f8a.webp",
            size: 62.4,
            __typename: "UploadFile",
          },
          __typename: "UploadFileEntity",
        },
        {
          attributes: {
            alternativeText: "Tulip Spring Green1",
            url: "/images/products/Tulip_Spring_Green_7d7ea25d20.webp",
            size: 91.85,
            __typename: "UploadFile",
          },
          __typename: "UploadFileEntity",
        },
      ],
      __typename: "UploadFileRelationResponseCollection",
    },
    __typename: "ProductEntity",
  },
  {
    name: "Table Clock - Stone peach",
    slug: "table-clock-stone-peach",
    MRP: 1950,
    sellingPrice: 1450,
    category: {
      data: {
        attributes: {
          name: "Table Clock",
          __typename: "Category",
        },
        __typename: "CategoryEntity",
      },
      __typename: "CategoryEntityResponse",
    },
    stock: 2,
    images: {
      data: [
        {
          attributes: {
            alternativeText: "Table Clock - Stone peach0",
            url: "/images/products/Table_Clock_Stone_peach_32452312e8.webp",
            size: 82.49,
            __typename: "UploadFile",
          },
          __typename: "UploadFileEntity",
        },
      ],
      __typename: "UploadFileRelationResponseCollection",
    },
    __typename: "ProductEntity",
  },
  {
    name: "Table Clock Code Pink",
    slug: "table-clock-code-pink",
    MRP: 1950,
    sellingPrice: 1450,
    category: {
      data: {
        attributes: {
          name: "Table Clock",
          __typename: "Category",
        },
        __typename: "CategoryEntity",
      },
      __typename: "CategoryEntityResponse",
    },
    stock: 3,
    images: {
      data: [
        {
          attributes: {
            alternativeText: "Table Clock Code Pink0",
            url: "/images/products/Table_Clock_Code_Pink_0c5133df00.webp",
            size: 54.87,
            __typename: "UploadFile",
          },
          __typename: "UploadFileEntity",
        },
      ],
      __typename: "UploadFileRelationResponseCollection",
    },
    __typename: "ProductEntity",
  },
  {
    name: "Table Clock Full moon",
    slug: "table-clock-full-moon",
    MRP: 1950,
    sellingPrice: 1450,
    category: {
      data: {
        attributes: {
          name: "Table Clock",
          __typename: "Category",
        },
        __typename: "CategoryEntity",
      },
      __typename: "CategoryEntityResponse",
    },
    stock: 3,
    images: {
      data: [
        {
          attributes: {
            alternativeText: "Table Clock Full moon0",
            url: "/images/products/Table_Clock_Full_moon_8ae51db075.webp",
            size: 66.58,
            __typename: "UploadFile",
          },
          __typename: "UploadFileEntity",
        },
      ],
      __typename: "UploadFileRelationResponseCollection",
    },
    __typename: "ProductEntity",
  },
  {
    name: "Table Clock Jubilee",
    slug: "table-clock-jubilee",
    MRP: 1950,
    sellingPrice: 1450,
    category: {
      data: {
        attributes: {
          name: "Table Clock",
          __typename: "Category",
        },
        __typename: "CategoryEntity",
      },
      __typename: "CategoryEntityResponse",
    },
    stock: 2,
    images: {
      data: [
        {
          attributes: {
            alternativeText: "Table Clock Jubilee0",
            url: "/images/products/Table_Clock_Jubilee_e50c114229.webp",
            size: 26.36,
            __typename: "UploadFile",
          },
          __typename: "UploadFileEntity",
        },
        {
          attributes: {
            alternativeText: "Table Clock Jubilee1",
            url: "/images/products/Table_Clock_Jubilee_0dc797a369.webp",
            size: 54.71,
            __typename: "UploadFile",
          },
          __typename: "UploadFileEntity",
        },
      ],
      __typename: "UploadFileRelationResponseCollection",
    },
    __typename: "ProductEntity",
  },
  {
    name: "Table Clock Spiral",
    slug: "table-clock-spiral",
    MRP: 1950,
    sellingPrice: 1450,
    category: {
      data: {
        attributes: {
          name: "Table Clock",
          __typename: "Category",
        },
        __typename: "CategoryEntity",
      },
      __typename: "CategoryEntityResponse",
    },
    stock: 3,
    images: {
      data: [
        {
          attributes: {
            alternativeText: "Table Clock Black Gold",
            url: "/images/products/Table_Clock_Black_Gold_4e039abd9e.webp",
            size: 48.25,
            __typename: "UploadFile",
          },
          __typename: "UploadFileEntity",
        },
        {
          attributes: {
            alternativeText: "Table Clock Spiral0",
            url: "/images/products/Table_Clock_Spiral_5aa5ac7de0.webp",
            size: 52.77,
            __typename: "UploadFile",
          },
          __typename: "UploadFileEntity",
        },
      ],
      __typename: "UploadFileRelationResponseCollection",
    },
    __typename: "ProductEntity",
  },
  {
    name: "Flower T - Lights (Green)",
    slug: "flower-green",
    MRP: 950,
    sellingPrice: 600,
    category: {
      data: {
        attributes: {
          name: "T-Light",
          __typename: "Category",
        },
        __typename: "CategoryEntity",
      },
      __typename: "CategoryEntityResponse",
    },
    stock: 2,
    images: {
      data: [
        {
          attributes: {
            alternativeText: null,
            url: "/images/products/Whats_App_Image_2024_10_03_at_22_32_34_a5835c5bbb.jpeg",
            size: 107.75,
            __typename: "UploadFile",
          },
          __typename: "UploadFileEntity",
        },
        {
          attributes: {
            alternativeText: null,
            url: "/images/products/Whats_App_Image_2024_10_03_at_22_32_34_1_5dc51e210c.jpeg",
            size: 107.75,
            __typename: "UploadFile",
          },
          __typename: "UploadFileEntity",
        },
      ],
      __typename: "UploadFileRelationResponseCollection",
    },
    __typename: "ProductEntity",
  },
  {
    name: "Swirl Black Stallion",
    slug: "swirl-black-stallion",
    MRP: 2199,
    sellingPrice: 1750,
    category: {
      data: {
        attributes: {
          name: "Swirl",
          __typename: "Category",
        },
        __typename: "CategoryEntity",
      },
      __typename: "CategoryEntityResponse",
    },
    stock: 2,
    images: {
      data: [
        {
          attributes: {
            alternativeText: "Swirl Black Stallion0",
            url: "/images/products/Swirl_Black_Stallion_1cddf237db.webp",
            size: 92.8,
            __typename: "UploadFile",
          },
          __typename: "UploadFileEntity",
        },
        {
          attributes: {
            alternativeText: "Swirl Black ",
            url: "/images/products/Swirl_Black_2nd_angle_7d789ac765.webp",
            size: 41.7,
            __typename: "UploadFile",
          },
          __typename: "UploadFileEntity",
        },
      ],
      __typename: "UploadFileRelationResponseCollection",
    },
    __typename: "ProductEntity",
  },
  {
    name: "Swirl Mini Stallion",
    slug: "swirl-mini-stallion",
    MRP: 850,
    sellingPrice: 650,
    category: {
      data: {
        attributes: {
          name: "Swirl",
          __typename: "Category",
        },
        __typename: "CategoryEntity",
      },
      __typename: "CategoryEntityResponse",
    },
    stock: 2,
    images: {
      data: [
        {
          attributes: {
            alternativeText: "Swirl Mini Stallion0",
            url: "/images/products/Swirl_Mini_Stallion_21c2fb9144.webp",
            size: 14.45,
            __typename: "UploadFile",
          },
          __typename: "UploadFileEntity",
        },
        {
          attributes: {
            alternativeText: "Swirl Mini Stallion1",
            url: "/images/products/Swirl_Mini_Stallion_f1974654f0.webp",
            size: 14.45,
            __typename: "UploadFile",
          },
          __typename: "UploadFileEntity",
        },
      ],
      __typename: "UploadFileRelationResponseCollection",
    },
    __typename: "ProductEntity",
  },
];
